//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const OM_CERTIFICATE_API_BASE_URL = new InjectionToken<string>('OM_CERTIFICATE_API_BASE_URL');

export class ServiceBaseConfig {
    public key: string;
}

export class ServiceBase {
    private readonly apiKey: string;
    private readonly apimHeaderName: string = 'Ocp-Apim-Subscription-Key';
    private readonly tenantIdHeaderName: string = 'TenantId';
    private readonly tenantIdLocalStorageKey: string = 'samplicity-dtp-current-client';
    private readonly idTokenKey: string = 'samplicity-id-token';

    constructor(config: ServiceBaseConfig) {
        this.apiKey = config.key;
    }

    protected transformOptions(options: any) {
        let headers: HttpHeaders = options.headers;

        if (this.apiKey) {
            headers = headers.append(this.apimHeaderName, this.apiKey);
        }

        const tenantId = sessionStorage.getItem(this.tenantIdLocalStorageKey);
        if (tenantId) {
            headers = headers.append(this.tenantIdHeaderName, tenantId);
        }

        const token = localStorage.getItem(this.idTokenKey);
        if (token) {
            headers = headers.append('Authorization', 'Bearer ' + token);
        }

        options.headers = headers;

        return Promise.resolve(options);
    }
}

@Injectable()
export class OrderManagementCertificate extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ServiceBaseConfig) configuration: ServiceBaseConfig, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(OM_CERTIFICATE_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param certificationId (optional) 
     * @return Success
     */
    getDataEntryCertificateDetailsById(certificationId: string | null | undefined): Observable<AjaxResponseOfDataEntryCertificationDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/GetDataEntryCertificateDetailsById?";
        if (certificationId !== undefined && certificationId !== null)
            url_ += "certificationId=" + encodeURIComponent("" + certificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDataEntryCertificateDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDataEntryCertificateDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfDataEntryCertificationDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfDataEntryCertificationDetailDto>;
        }));
    }

    protected processGetDataEntryCertificateDetailsById(response: HttpResponseBase): Observable<AjaxResponseOfDataEntryCertificationDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfDataEntryCertificationDetailDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    unlockOrderById(id: string | null | undefined): Observable<AjaxResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/services/app/Certification/UnlockOrderById?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(
            _observableMergeMap(transformedOptions_ => {
                return this.http.request("post", url_, transformedOptions_);
            }),
            _observableMergeMap((response_: any) => {
                return this.processUnlockOrderById(response_);
            }),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUnlockOrderById(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as Observable<AjaxResponseOfBoolean>;
                    }
                } else {
                    return _observableThrow(response_) as Observable<AjaxResponseOfBoolean>;
                }
            })
        );
    }

    protected processUnlockOrderById(response: HttpResponseBase): Observable<AjaxResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfBoolean.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }

        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param extendLock (optional) 
     * @return Success
     */

    lockOrderById(id: string | null | undefined, extendLock: boolean | null | undefined): Observable<AjaxResponseOfLockAckDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/LockOrderById?";

        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (extendLock !== undefined && extendLock !== null)
            url_ += "extendLock=" + encodeURIComponent("" + extendLock) + "&";

        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(
            _observableMergeMap(transformedOptions_ =>
                this.http.request("post", url_, transformedOptions_)
            ),
            _observableMergeMap((response_: any) =>
                this.processLockOrderById(response_)
            ),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processLockOrderById(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as Observable<AjaxResponseOfLockAckDto>;
                    }
                } else {
                    return _observableThrow(response_) as Observable<AjaxResponseOfLockAckDto>;
                }
            })
        );
    }

    protected processLockOrderById(response: HttpResponseBase): Observable<AjaxResponseOfLockAckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfLockAckDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }

        return _observableOf(null as any);
    }

    /**
     * @param src (optional) 
     * @return Success
     */
    saveDataEntryCertificateDetails(src: DataEntryCertificationDetailDto | null | undefined): Observable<AjaxResponseOfDataEntryCertificationDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/SaveDataEntryCertificateDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(src);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(
            _observableMergeMap(transformedOptions_ =>
                this.http.request("post", url_, transformedOptions_)
            ),
            _observableMergeMap((response_: any) =>
                this.processSaveDataEntryCertificateDetails(response_)
            ),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSaveDataEntryCertificateDetails(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as Observable<AjaxResponseOfDataEntryCertificationDetailDto>;
                    }
                } else {
                    return _observableThrow(response_) as Observable<AjaxResponseOfDataEntryCertificationDetailDto>;
                }
            })
        );
    }

    protected processSaveDataEntryCertificateDetails(response: HttpResponseBase): Observable<AjaxResponseOfDataEntryCertificationDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfDataEntryCertificationDetailDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }

        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderLockInfo(id: string | null | undefined): Observable<AjaxResponseOfLockInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/GetOrderLockInfo?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(
            _observableMergeMap(transformedOptions_ =>
                this.http.request("get", url_, transformedOptions_)
            ),
            _observableMergeMap((response_: any) =>
                this.processGetOrderLockInfo(response_)
            ),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetOrderLockInfo(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as Observable<AjaxResponseOfLockInfoDto>;
                    }
                } else {
                    return _observableThrow(response_) as Observable<AjaxResponseOfLockInfoDto>;
                }
            })
        );
    }

    protected processGetOrderLockInfo(response: HttpResponseBase): Observable<AjaxResponseOfLockInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfLockInfoDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }

        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCertificateDetailLockInfo(id: string | null | undefined): Observable<AjaxResponseOfLockInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/GetCertificateDetailLockInfo?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(
            _observableMergeMap(transformedOptions_ => this.http.request("get", url_, transformedOptions_)),
            _observableMergeMap((response_: any) => this.processGetCertificateDetailLockInfo(response_)),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetCertificateDetailLockInfo(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as any as Observable<AjaxResponseOfLockInfoDto>;
                    }
                } else {
                    return _observableThrow(response_) as any as Observable<AjaxResponseOfLockInfoDto>;
                }
            })
        );
    }

    protected processGetCertificateDetailLockInfo(response: HttpResponseBase): Observable<AjaxResponseOfLockInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AjaxResponseOfLockInfoDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }

        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    searchDataEntryCertifications(filter: CertificationSearchFilterDto | null | undefined): Observable<AjaxResponseOfPagedResultOfCertificationSearchDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/SearchDataEntryCertifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchDataEntryCertifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDataEntryCertifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfPagedResultOfCertificationSearchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfPagedResultOfCertificationSearchDto>;
        }));
    }

    protected processSearchDataEntryCertifications(response: HttpResponseBase): Observable<AjaxResponseOfPagedResultOfCertificationSearchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AjaxResponseOfPagedResultOfCertificationSearchDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param certificationId (optional) 
     * @return Success
     */

    getSubmittedDataEntryCertificateDetailsById(certificationId: string | null | undefined): Observable<AjaxResponseOfCertificationDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/GetSubmittedDataEntryCertificateDetailsById?";
        if (certificationId !== undefined && certificationId !== null)
            url_ += "certificationId=" + encodeURIComponent("" + certificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(
            _observableMergeMap(transformedOptions_ => {
                return this.http.request("get", url_, transformedOptions_);
            }),
            _observableMergeMap((response_: any) => {
                return this.processGetSubmittedDataEntryCertificateDetailsById(response_);
            }),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetSubmittedDataEntryCertificateDetailsById(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as Observable<AjaxResponseOfCertificationDetailDto>;
                    }
                } else {
                    return _observableThrow(response_) as Observable<AjaxResponseOfCertificationDetailDto>;
                }
            })
        );
    }

    protected processGetSubmittedDataEntryCertificateDetailsById(response: HttpResponseBase): Observable<AjaxResponseOfCertificationDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: any = null;
                    let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = AjaxResponseOfCertificationDetailDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }

        return _observableOf(null as any);
    }

}

export class AjaxResponseOfCertificationDetailDto implements IAjaxResponseOfCertificationDetailDto {
    result: CertificationDetailDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfCertificationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? CertificationDetailDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfCertificationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfCertificationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data; 
    }

    clone(): AjaxResponseOfCertificationDetailDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfCertificationDetailDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfCertificationDetailDto {
    result: CertificationDetailDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfDataEntryCertificationDetailDto implements IAjaxResponseOfDataEntryCertificationDetailDto {
    result: DataEntryCertificationDetailDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfDataEntryCertificationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? DataEntryCertificationDetailDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfDataEntryCertificationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfDataEntryCertificationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfDataEntryCertificationDetailDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfDataEntryCertificationDetailDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfDataEntryCertificationDetailDto {
    result: DataEntryCertificationDetailDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class DataEntryCertificationDetailDto implements IDataEntryCertificationDetailDto {
    certificationDetailId: string | undefined;
    tenantName: string | undefined;
    /** Communication ID:- This is not in reference to communication database foriegn key
should be traeted as seprate entity. */
    communicationId: string | undefined;
    communicationRecievedDate: Date | undefined;
    batchDate: Date | undefined;
    batchNumber: string | undefined;
    formId: string | undefined;
    certificationCreationDate: Date | undefined;
    programName: string | undefined;
    recordType: string | undefined;
    lockedFlag: boolean | undefined;
    approvedByUserProfile_FK: string | undefined;
    program_FK: string | undefined;
    hospital_FK: string | undefined;
    pharmacyHospital_FK: string | undefined;
    pharmacy_FK: string | undefined;
    jobNumber: string | undefined;
    pharmacyContactFirstName: string | undefined;
    pharmacyContactLastName: string | undefined;
    pharmacyName: string | undefined;
    pharmacyAddress1Text: string | undefined;
    pharmacyAddress2Text: string | undefined;
    pharmacyAddress3Text: string | undefined;
    pharmacyAddress4Text: string | undefined;
    pharmacyCityName: string | undefined;
    pharmacyStateCode: string | undefined;
    pharmacyCountryCode: string | undefined;
    pharmacyZipCode: string | undefined;
    pharmacyContactFirstNameCheck: boolean | undefined;
    pharmacyContactLastNameCheck: boolean | undefined;
    pharmacyFirstNameCheck: boolean | undefined;
    pharmacyAddress1TextCheck: boolean | undefined;
    pharmacyAddress2TextCheck: boolean | undefined;
    pharmacyStateCodeFKCheck: boolean | undefined;
    pharmacyCityNameCheck: boolean | undefined;
    pharmacyZipCodeCheck: boolean | undefined;
    reasonForModification: string | undefined;
    isSignature: boolean | undefined;
    isSignatureStamped: boolean | undefined;
    signedDate: Date | undefined;
    contactComments: string | undefined;
    isAdverseEvent: boolean | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    formIdMissingFlag: boolean | undefined;
    formIdNotApplicableFlag: boolean | undefined;
    formIdUnmatchedFlag: boolean | undefined;
    hospitalFirstName: string | undefined;
    hospitalLastName: string | undefined;
    hospitalAddress: string | undefined;
    hospitalSLN: string | undefined;
    hospitalEnrollmentID: string | undefined;
    hospitalKID: string | undefined;
    hospitalEmail: string | undefined;
    submitFlag: boolean | undefined;
    names: LocalizedValue[] | undefined;

    constructor(data?: IDataEntryCertificationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificationDetailId = _data["certificationDetailId"];
            this.tenantName = _data["tenantName"];
            this.communicationId = _data["communicationId"];
            this.communicationRecievedDate = _data["communicationRecievedDate"] ? new Date(_data["communicationRecievedDate"].toString()) : <any>undefined;
            this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>undefined;
            this.batchNumber = _data["batchNumber"];
            this.formId = _data["formId"];
            this.certificationCreationDate = _data["certificationCreationDate"] ? new Date(_data["certificationCreationDate"].toString()) : <any>undefined;
            this.programName = _data["programName"];
            this.recordType = _data["recordType"];
            this.lockedFlag = _data["lockedFlag"];
            this.approvedByUserProfile_FK = _data["approvedByUserProfile_FK"];
            this.program_FK = _data["program_FK"];
            this.hospital_FK = _data["hospital_FK"];
            this.pharmacyHospital_FK = _data["pharmacyHospital_FK"];
            this.pharmacy_FK = _data["pharmacy_FK"];
            this.jobNumber = _data["jobNumber"];
            this.pharmacyContactFirstName = _data["pharmacyContactFirstName"];
            this.pharmacyContactLastName = _data["pharmacyContactLastName"];
            this.pharmacyName = _data["pharmacyName"];
            this.pharmacyAddress1Text = _data["pharmacyAddress1Text"];
            this.pharmacyAddress2Text = _data["pharmacyAddress2Text"];
            this.pharmacyAddress3Text = _data["pharmacyAddress3Text"];
            this.pharmacyAddress4Text = _data["pharmacyAddress4Text"];
            this.pharmacyCityName = _data["pharmacyCityName"];
            this.pharmacyStateCode = _data["pharmacyStateCode"];
            this.pharmacyCountryCode = _data["pharmacyCountryCode"];
            this.pharmacyZipCode = _data["pharmacyZipCode"];
            this.pharmacyContactFirstNameCheck = _data["pharmacyContactFirstNameCheck"];
            this.pharmacyContactLastNameCheck = _data["pharmacyContactLastNameCheck"];
            this.pharmacyFirstNameCheck = _data["pharmacyFirstNameCheck"];
            this.pharmacyAddress1TextCheck = _data["pharmacyAddress1TextCheck"];
            this.pharmacyAddress2TextCheck = _data["pharmacyAddress2TextCheck"];
            this.pharmacyStateCodeFKCheck = _data["pharmacyStateCodeFKCheck"];
            this.pharmacyCityNameCheck = _data["pharmacyCityNameCheck"];
            this.pharmacyZipCodeCheck = _data["pharmacyZipCodeCheck"];
            this.reasonForModification = _data["reasonForModification"];
            this.isSignature = _data["isSignature"];
            this.isSignatureStamped = _data["isSignatureStamped"];
            this.signedDate = _data["signedDate"] ? new Date(_data["signedDate"].toString()) : <any>undefined;
            this.contactComments = _data["contactComments"];
            this.isAdverseEvent = _data["isAdverseEvent"];
            this.lastModificationTime = _data["lastModificationTime"] ? new Date(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.formIdMissingFlag = _data["formIdMissingFlag"];
            this.formIdNotApplicableFlag = _data["formIdNotApplicableFlag"];
            this.formIdUnmatchedFlag = _data["formIdUnmatchedFlag"];
            this.hospitalFirstName = _data["hospitalFirstName"];
            this.hospitalLastName = _data["hospitalLastName"];
            this.hospitalAddress = _data["hospitalAddress"];
            this.hospitalSLN = _data["hospitalSLN"];
            this.hospitalEnrollmentID = _data["hospitalEnrollmentID"];
            this.hospitalKID = _data["hospitalKID"];
            this.hospitalEmail = _data["hospitalEmail"];
            this.submitFlag = _data["submitFlag"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataEntryCertificationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataEntryCertificationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificationDetailId"] = this.certificationDetailId;
        data["tenantName"] = this.tenantName;
        data["communicationId"] = this.communicationId;
        data["communicationRecievedDate"] = this.communicationRecievedDate ? this.communicationRecievedDate.toISOString() : <any>undefined;
        data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["formId"] = this.formId;
        data["certificationCreationDate"] = this.certificationCreationDate ? this.certificationCreationDate.toISOString() : <any>undefined;
        data["programName"] = this.programName;
        data["recordType"] = this.recordType;
        data["lockedFlag"] = this.lockedFlag;
        data["approvedByUserProfile_FK"] = this.approvedByUserProfile_FK;
        data["program_FK"] = this.program_FK;
        data["hospital_FK"] = this.hospital_FK;
        data["pharmacyHospital_FK"] = this.pharmacyHospital_FK;
        data["pharmacy_FK"] = this.pharmacy_FK;
        data["jobNumber"] = this.jobNumber;
        data["pharmacyContactFirstName"] = this.pharmacyContactFirstName;
        data["pharmacyContactLastName"] = this.pharmacyContactLastName;
        data["pharmacyName"] = this.pharmacyName;
        data["pharmacyAddress1Text"] = this.pharmacyAddress1Text;
        data["pharmacyAddress2Text"] = this.pharmacyAddress2Text;
        data["pharmacyAddress3Text"] = this.pharmacyAddress3Text;
        data["pharmacyAddress4Text"] = this.pharmacyAddress4Text;
        data["pharmacyCityName"] = this.pharmacyCityName;
        data["pharmacyStateCode"] = this.pharmacyStateCode;
        data["pharmacyCountryCode"] = this.pharmacyCountryCode;
        data["pharmacyZipCode"] = this.pharmacyZipCode;
        data["pharmacyContactFirstNameCheck"] = this.pharmacyContactFirstNameCheck;
        data["pharmacyContactLastNameCheck"] = this.pharmacyContactLastNameCheck;
        data["pharmacyFirstNameCheck"] = this.pharmacyFirstNameCheck;
        data["pharmacyAddress1TextCheck"] = this.pharmacyAddress1TextCheck;
        data["pharmacyAddress2TextCheck"] = this.pharmacyAddress2TextCheck;
        data["pharmacyStateCodeFKCheck"] = this.pharmacyStateCodeFKCheck;
        data["pharmacyCityNameCheck"] = this.pharmacyCityNameCheck;
        data["pharmacyZipCodeCheck"] = this.pharmacyZipCodeCheck;
        data["reasonForModification"] = this.reasonForModification;
        data["isSignature"] = this.isSignature;
        data["isSignatureStamped"] = this.isSignatureStamped;
        data["signedDate"] = this.signedDate ? this.signedDate.toISOString() : <any>undefined;
        data["contactComments"] = this.contactComments;
        data["isAdverseEvent"] = this.isAdverseEvent;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["formIdMissingFlag"] = this.formIdMissingFlag;
        data["formIdNotApplicableFlag"] = this.formIdNotApplicableFlag;
        data["formIdUnmatchedFlag"] = this.formIdUnmatchedFlag;
        data["hospitalFirstName"] = this.hospitalFirstName;
        data["hospitalLastName"] = this.hospitalLastName;
        data["hospitalAddress"] = this.hospitalAddress;
        data["hospitalSLN"] = this.hospitalSLN;
        data["hospitalEnrollmentID"] = this.hospitalEnrollmentID;
        data["hospitalKID"] = this.hospitalKID;
        data["hospitalEmail"] = this.hospitalEmail;
        data["submitFlag"] = this.submitFlag;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        return data;
    }

    clone(): DataEntryCertificationDetailDto {
        const json = this.toJSON();
        let result = new DataEntryCertificationDetailDto();
        result.init(json);
        return result;
    }
}

export interface IDataEntryCertificationDetailDto {
    certificationDetailId: string | undefined;
    tenantName: string | undefined;
    /** Communication ID:- This is not in reference to communication database foriegn key
should be traeted as seprate entity. */
    communicationId: string | undefined;
    communicationRecievedDate: Date | undefined;
    batchDate: Date | undefined;
    batchNumber: string | undefined;
    formId: string | undefined;
    certificationCreationDate: Date | undefined;
    programName: string | undefined;
    recordType: string | undefined;
    lockedFlag: boolean | undefined;
    approvedByUserProfile_FK: string | undefined;
    program_FK: string | undefined;
    hospital_FK: string | undefined;
    pharmacyHospital_FK: string | undefined;
    pharmacy_FK: string | undefined;
    jobNumber: string | undefined;
    pharmacyContactFirstName: string | undefined;
    pharmacyContactLastName: string | undefined;
    pharmacyName: string | undefined;
    pharmacyAddress1Text: string | undefined;
    pharmacyAddress2Text: string | undefined;
    pharmacyAddress3Text: string | undefined;
    pharmacyAddress4Text: string | undefined;
    pharmacyCityName: string | undefined;
    pharmacyStateCode: string | undefined;
    pharmacyCountryCode: string | undefined;
    pharmacyZipCode: string | undefined;
    pharmacyContactFirstNameCheck: boolean | undefined;
    pharmacyContactLastNameCheck: boolean | undefined;
    pharmacyFirstNameCheck: boolean | undefined;
    pharmacyAddress1TextCheck: boolean | undefined;
    pharmacyAddress2TextCheck: boolean | undefined;
    pharmacyStateCodeFKCheck: boolean | undefined;
    pharmacyCityNameCheck: boolean | undefined;
    pharmacyZipCodeCheck: boolean | undefined;
    reasonForModification: string | undefined;
    isSignature: boolean | undefined;
    isSignatureStamped: boolean | undefined;
    signedDate: Date | undefined;
    contactComments: string | undefined;
    isAdverseEvent: boolean | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    formIdMissingFlag: boolean | undefined;
    formIdNotApplicableFlag: boolean | undefined;
    formIdUnmatchedFlag: boolean | undefined;
    hospitalFirstName: string | undefined;
    hospitalLastName: string | undefined;
    hospitalAddress: string | undefined;
    hospitalSLN: string | undefined;
    hospitalEnrollmentID: string | undefined;
    hospitalKID: string | undefined;
    hospitalEmail: string | undefined;
    submitFlag: boolean | undefined;
    names: LocalizedValue[] | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

// export class LocalizedValue implements ILocalizedValue {
//     language: LocalizedValueLanguage | undefined;
//     value: string | undefined;

//     constructor(data?: ILocalizedValue) {
//         if (data) {
//             for (var property in data) {
//                 if (data.hasOwnProperty(property))
//                     (<any>this)[property] = (<any>data)[property];
//             }
//         }
//     }

//     init(_data?: any) {
//         if (_data) {
//             this.language = _data["language"];
//             this.value = _data["value"];
//         }
//     }

//     static fromJS(data: any): LocalizedValue {
//         data = typeof data === 'object' ? data : {};
//         let result = new LocalizedValue();
//         result.init(data);
//         return result;
//     }

//     toJSON(data?: any) {
//         data = typeof data === 'object' ? data : {};
//         data["language"] = this.language;
//         data["value"] = this.value;
//         return data; 
//     }

//     clone(): LocalizedValue {
//         const json = this.toJSON();
//         let result = new LocalizedValue();
//         result.init(json);
//         return result;
//     }
// }

export interface ILocalizedValue {
    language: LocalizedValueLanguage | undefined;
    value: string | undefined;
}


export class ValidationErrorInfo implements IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}
export class AjaxResponseOfBoolean implements IAjaxResponseOfBoolean {
    result: boolean | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfBoolean {
        const json = this.toJSON();
        let result = new AjaxResponseOfBoolean();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfBoolean {
    result: boolean | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfLockAckDto implements IAjaxResponseOfLockAckDto {
    result: LockAckDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfLockAckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? LockAckDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfLockAckDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfLockAckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfLockAckDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfLockAckDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfLockAckDto {
    result: LockAckDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class LockAckDto implements ILockAckDto {
    isLocked: boolean | undefined;
    lockConfig: LockConfigDto | undefined;

    constructor(data?: ILockAckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLocked = _data["isLocked"];
            this.lockConfig = _data["lockConfig"] ? LockConfigDto.fromJS(_data["lockConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LockAckDto {
        data = typeof data === 'object' ? data : {};
        let result = new LockAckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLocked"] = this.isLocked;
        data["lockConfig"] = this.lockConfig ? this.lockConfig.toJSON() : <any>undefined;
        return data;
    }

    clone(): LockAckDto {
        const json = this.toJSON();
        let result = new LockAckDto();
        result.init(json);
        return result;
    }
}

export interface ILockAckDto {
    isLocked: boolean | undefined;
    lockConfig: LockConfigDto | undefined;
}

export class LockConfigDto implements ILockConfigDto {
    warnLockExpiryFromInSeconds: number | undefined;
    expireLockDurationInSeconds: number | undefined;

    constructor(data?: ILockConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warnLockExpiryFromInSeconds = _data["warnLockExpiryFromInSeconds"];
            this.expireLockDurationInSeconds = _data["expireLockDurationInSeconds"];
        }
    }

    static fromJS(data: any): LockConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new LockConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warnLockExpiryFromInSeconds"] = this.warnLockExpiryFromInSeconds;
        data["expireLockDurationInSeconds"] = this.expireLockDurationInSeconds;
        return data;
    }

    clone(): LockConfigDto {
        const json = this.toJSON();
        let result = new LockConfigDto();
        result.init(json);
        return result;
    }
}

export interface ILockConfigDto {
    warnLockExpiryFromInSeconds: number | undefined;
    expireLockDurationInSeconds: number | undefined;
}

export class AjaxResponseOfLockInfoDto implements IAjaxResponseOfLockInfoDto {
    result: LockInfoDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfLockInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? LockInfoDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfLockInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfLockInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfLockInfoDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfLockInfoDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfLockInfoDto {
    result: LockInfoDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class LockInfoDto implements ILockInfoDto {
    lock: LockDto | undefined;
    lockConfig: LockConfigDto | undefined;

    constructor(data?: ILockInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lock = _data["lock"] ? LockDto.fromJS(_data["lock"]) : <any>undefined;
            this.lockConfig = _data["lockConfig"] ? LockConfigDto.fromJS(_data["lockConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LockInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LockInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lock"] = this.lock ? this.lock.toJSON() : <any>undefined;
        data["lockConfig"] = this.lockConfig ? this.lockConfig.toJSON() : <any>undefined;
        return data;
    }

    clone(): LockInfoDto {
        const json = this.toJSON();
        let result = new LockInfoDto();
        result.init(json);
        return result;
    }
}

export interface ILockInfoDto {
    lock: LockDto | undefined;
    lockConfig: LockConfigDto | undefined;
}

export class LockDto implements ILockDto {
    isLocked: boolean | undefined;
    lockedByUserId: number | undefined;
    lockTimestamp: Date | undefined;
    lockExpiryTimestamp: Date | undefined;
    unlockedByUserId: number | undefined;
    unlockTimestamp: Date | undefined;
    unlockReasonId: string | undefined;

    constructor(data?: ILockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLocked = _data["isLocked"];
            this.lockedByUserId = _data["lockedByUserId"];
            this.lockTimestamp = _data["lockTimestamp"] ? new Date(_data["lockTimestamp"].toString()) : <any>undefined;
            this.lockExpiryTimestamp = _data["lockExpiryTimestamp"] ? new Date(_data["lockExpiryTimestamp"].toString()) : <any>undefined;
            this.unlockedByUserId = _data["unlockedByUserId"];
            this.unlockTimestamp = _data["unlockTimestamp"] ? new Date(_data["unlockTimestamp"].toString()) : <any>undefined;
            this.unlockReasonId = _data["unlockReasonId"];
        }
    }

    static fromJS(data: any): LockDto {
        data = typeof data === 'object' ? data : {};
        let result = new LockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLocked"] = this.isLocked;
        data["lockedByUserId"] = this.lockedByUserId;
        data["lockTimestamp"] = this.lockTimestamp ? this.lockTimestamp.toISOString() : <any>undefined;
        data["lockExpiryTimestamp"] = this.lockExpiryTimestamp ? this.lockExpiryTimestamp.toISOString() : <any>undefined;
        data["unlockedByUserId"] = this.unlockedByUserId;
        data["unlockTimestamp"] = this.unlockTimestamp ? this.unlockTimestamp.toISOString() : <any>undefined;
        data["unlockReasonId"] = this.unlockReasonId;
        return data;
    }

    clone(): LockDto {
        const json = this.toJSON();
        let result = new LockDto();
        result.init(json);
        return result;
    }
}

export interface ILockDto {
    isLocked: boolean | undefined;
    lockedByUserId: number | undefined;
    lockTimestamp: Date | undefined;
    lockExpiryTimestamp: Date | undefined;
    unlockedByUserId: number | undefined;
    unlockTimestamp: Date | undefined;
    unlockReasonId: string | undefined;
}

export class CertificationSearchFilterDto implements ICertificationSearchFilterDto {
    programName: string | undefined;
    jobNumber: string | undefined;
    communicationId: string | undefined;
    communicationRecievedDateFrom: Date | undefined;
    communicationRecievedDateTo: Date | undefined;
    recordType: string[] | undefined;
    unlockedForEditingFlag: boolean | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    sortBy: string | undefined;
    filterString: string | undefined;

    constructor(data?: ICertificationSearchFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.programName = _data["programName"];
            this.jobNumber = _data["jobNumber"];
            this.communicationId = _data["communicationId"];
            this.communicationRecievedDateFrom = _data["communicationRecievedDateFrom"] ? new Date(_data["communicationRecievedDateFrom"].toString()) : <any>undefined;
            this.communicationRecievedDateTo = _data["communicationRecievedDateTo"] ? new Date(_data["communicationRecievedDateTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["recordType"])) {
                this.recordType = [] as any;
                for (let item of _data["recordType"])
                    this.recordType.push(item);
            }
            this.unlockedForEditingFlag = _data["unlockedForEditingFlag"];
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
            this.sortBy = _data["sortBy"];
            this.filterString = _data["filterString"];
        }
    }

    static fromJS(data: any): CertificationSearchFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationSearchFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["programName"] = this.programName;
        data["jobNumber"] = this.jobNumber;
        data["communicationId"] = this.communicationId;
        data["communicationRecievedDateFrom"] = this.communicationRecievedDateFrom ? this.communicationRecievedDateFrom.toISOString() : <any>undefined;
        data["communicationRecievedDateTo"] = this.communicationRecievedDateTo ? this.communicationRecievedDateTo.toISOString() : <any>undefined;
        if (Array.isArray(this.recordType)) {
            data["recordType"] = [];
            for (let item of this.recordType)
                data["recordType"].push(item);
        }
        data["unlockedForEditingFlag"] = this.unlockedForEditingFlag;
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        data["sortBy"] = this.sortBy;
        data["filterString"] = this.filterString;
        return data;
    }

    clone(): CertificationSearchFilterDto {
        const json = this.toJSON();
        let result = new CertificationSearchFilterDto();
        result.init(json);
        return result;
    }
}

export interface ICertificationSearchFilterDto {
    programName: string | undefined;
    jobNumber: string | undefined;
    communicationId: string | undefined;
    communicationRecievedDateFrom: Date | undefined;
    communicationRecievedDateTo: Date | undefined;
    recordType: string[] | undefined;
    unlockedForEditingFlag: boolean | undefined;
    pageSize: number | undefined;
    pageNumber: number | undefined;
    sortBy: string | undefined;
    filterString: string | undefined;
}

export class AjaxResponseOfPagedResultOfCertificationSearchDto implements IAjaxResponseOfPagedResultOfCertificationSearchDto {
    result: PagedResultOfCertificationSearchDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfPagedResultOfCertificationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? PagedResultOfCertificationSearchDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfPagedResultOfCertificationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfPagedResultOfCertificationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfPagedResultOfCertificationSearchDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfPagedResultOfCertificationSearchDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfPagedResultOfCertificationSearchDto {
    result: PagedResultOfCertificationSearchDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class PagedResultOfCertificationSearchDto implements IPagedResultOfCertificationSearchDto {
    totalCount: number | undefined;
    items: CertificationSearchDto[] | undefined;

    constructor(data?: IPagedResultOfCertificationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CertificationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultOfCertificationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCertificationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PagedResultOfCertificationSearchDto {
        const json = this.toJSON();
        let result = new PagedResultOfCertificationSearchDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultOfCertificationSearchDto {
    totalCount: number | undefined;
    items: CertificationSearchDto[] | undefined;
}

export class CertificationSearchDto implements ICertificationSearchDto {
    id: string | undefined;
    communicationId: string | undefined;
    recordReceivedDate: Date | undefined;
    programName: string | undefined;
    recordType: string | undefined;
    jobNumber: string | undefined;
    locked: boolean | undefined;
    modifiedBy: number | undefined;
    names: LocalizedValue[] | undefined;

    constructor(data?: ICertificationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.communicationId = _data["communicationId"];
            this.recordReceivedDate = _data["recordReceivedDate"] ? new Date(_data["recordReceivedDate"].toString()) : <any>undefined;
            this.programName = _data["programName"];
            this.recordType = _data["recordType"];
            this.jobNumber = _data["jobNumber"];
            this.locked = _data["locked"];
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names.push(LocalizedValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CertificationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["communicationId"] = this.communicationId;
        data["recordReceivedDate"] = this.recordReceivedDate ? this.recordReceivedDate.toISOString() : <any>undefined;
        data["programName"] = this.programName;
        data["recordType"] = this.recordType;
        data["jobNumber"] = this.jobNumber;
        data["locked"] = this.locked;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item.toJSON());
        }
        return data;
    }

    clone(): CertificationSearchDto {
        const json = this.toJSON();
        let result = new CertificationSearchDto();
        result.init(json);
        return result;
    }
}

export interface ICertificationSearchDto {
    id: string | undefined;
    communicationId: string | undefined;
    recordReceivedDate: Date | undefined;
    programName: string | undefined;
    recordType: string | undefined;
    jobNumber: string | undefined;
    locked: boolean | undefined;
    modifiedBy: number | undefined;
    names: LocalizedValue[] | undefined;
}

export class LocalizedValue implements ILocalizedValue {
    language: LocalizedValueLanguage | undefined;
    value: string | undefined;

    constructor(data?: ILocalizedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LocalizedValue {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }

    clone(): LocalizedValue {
        const json = this.toJSON();
        let result = new LocalizedValue();
        result.init(json);
        return result;
    }
}

export interface ILocalizedValue {
    language: LocalizedValueLanguage | undefined;
    value: string | undefined;
}

export interface IAjaxResponseOfCertificationDetailDto {
    result: CertificationDetailDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CertificationDetailDto implements ICertificationDetailDto {
    certificationDetailId: string | undefined;
    tenantName: string | undefined;
    /** Communication ID:- This is not in reference to communication database foriegn key
should be traeted as seprate entity. */
    communicationId: string | undefined;
    communicationRecievedDate: Date | undefined;
    batchDate: Date | undefined;
    batchNumber: string | undefined;
    formId: string | undefined;
    certificationCreationDate: Date | undefined;
    programName: string | undefined;
    programId: string | undefined;
    hospitalId: string | undefined;
    pharmacyHospitalId: string | undefined;
    pharmacyId: string | undefined;
    jobNumber: string | undefined;
    pharmacyContactFirstName: string | undefined;
    pharmacyContactLastName: string | undefined;
    pharmacyName: string | undefined;
    pharmacyAddress1Text: string | undefined;
    pharmacyAddress2Text: string | undefined;
    pharmacyAddress3Text: string | undefined;
    pharmacyAddress4Text: string | undefined;
    pharmacyCityName: string | undefined;
    pharmacyStateCode: string | undefined;
    pharmacyCountryCode: string | undefined;
    pharmacyZipCode: string | undefined;
    pharmacyContactFirstNameCheck: boolean | undefined;
    pharmacyContactLastNameCheck: boolean | undefined;
    pharmacyFirstNameCheck: boolean | undefined;
    pharmacyAddress1TextCheck: boolean | undefined;
    pharmacyAddress2TextCheck: boolean | undefined;
    pharmacyStateCodeFKCheck: boolean | undefined;
    pharmacyCityNameCheck: boolean | undefined;
    pharmacyZipCodeCheck: boolean | undefined;
    reasonForModification: string | undefined;
    isSignature: boolean | undefined;
    isSignatureStamped: boolean | undefined;
    signedDate: Date | undefined;
    contactComments: string | undefined;
    isAdverseEvent: boolean | undefined;
    affiliationTypeClassificationValueId: string | undefined;
    slnLicenseExpirationDate: Date | undefined;
    slnStateCode: string | undefined;
    stateLicenseNbr: string | undefined;
    pharmacyKID: string | undefined;
    pharmacyContactEmail: string | undefined;
    pharmacyContactFAX: string | undefined;
    pharmacyContactPhoneNumber: string | undefined;

    constructor(data?: ICertificationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificationDetailId = _data["certificationDetailId"];
            this.tenantName = _data["tenantName"];
            this.communicationId = _data["communicationId"];
            this.communicationRecievedDate = _data["communicationRecievedDate"] ? new Date(_data["communicationRecievedDate"].toString()) : <any>undefined;
            this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : <any>undefined;
            this.batchNumber = _data["batchNumber"];
            this.formId = _data["formId"];
            this.certificationCreationDate = _data["certificationCreationDate"] ? new Date(_data["certificationCreationDate"].toString()) : <any>undefined;
            this.programName = _data["programName"];
            this.programId = _data["programId"];
            this.hospitalId = _data["hospitalId"];
            this.pharmacyHospitalId = _data["pharmacyHospitalId"];
            this.pharmacyId = _data["pharmacyId"];
            this.jobNumber = _data["jobNumber"];
            this.pharmacyContactFirstName = _data["pharmacyContactFirstName"];
            this.pharmacyContactLastName = _data["pharmacyContactLastName"];
            this.pharmacyName = _data["pharmacyName"];
            this.pharmacyAddress1Text = _data["pharmacyAddress1Text"];
            this.pharmacyAddress2Text = _data["pharmacyAddress2Text"];
            this.pharmacyAddress3Text = _data["pharmacyAddress3Text"];
            this.pharmacyAddress4Text = _data["pharmacyAddress4Text"];
            this.pharmacyCityName = _data["pharmacyCityName"];
            this.pharmacyStateCode = _data["pharmacyStateCode"];
            this.pharmacyCountryCode = _data["pharmacyCountryCode"];
            this.pharmacyZipCode = _data["pharmacyZipCode"];
            this.pharmacyContactFirstNameCheck = _data["pharmacyContactFirstNameCheck"];
            this.pharmacyContactLastNameCheck = _data["pharmacyContactLastNameCheck"];
            this.pharmacyFirstNameCheck = _data["pharmacyFirstNameCheck"];
            this.pharmacyAddress1TextCheck = _data["pharmacyAddress1TextCheck"];
            this.pharmacyAddress2TextCheck = _data["pharmacyAddress2TextCheck"];
            this.pharmacyStateCodeFKCheck = _data["pharmacyStateCodeFKCheck"];
            this.pharmacyCityNameCheck = _data["pharmacyCityNameCheck"];
            this.pharmacyZipCodeCheck = _data["pharmacyZipCodeCheck"];
            this.reasonForModification = _data["reasonForModification"];
            this.isSignature = _data["isSignature"];
            this.isSignatureStamped = _data["isSignatureStamped"];
            this.signedDate = _data["signedDate"] ? new Date(_data["signedDate"].toString()) : <any>undefined;
            this.contactComments = _data["contactComments"];
            this.isAdverseEvent = _data["isAdverseEvent"];
            this.affiliationTypeClassificationValueId = _data["affiliationTypeClassificationValueId"];
            this.slnLicenseExpirationDate = _data["slnLicenseExpirationDate"] ? new Date(_data["slnLicenseExpirationDate"].toString()) : <any>undefined;
            this.slnStateCode = _data["slnStateCode"];
            this.stateLicenseNbr = _data["stateLicenseNbr"];
            this.pharmacyKID = _data["pharmacyKID"];
            this.pharmacyContactEmail = _data["pharmacyContactEmail"];
            this.pharmacyContactFAX = _data["pharmacyContactFAX"];
            this.pharmacyContactPhoneNumber = _data["pharmacyContactPhoneNumber"];
        }
    }

    static fromJS(data: any): CertificationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificationDetailId"] = this.certificationDetailId;
        data["tenantName"] = this.tenantName;
        data["communicationId"] = this.communicationId;
        data["communicationRecievedDate"] = this.communicationRecievedDate ? this.communicationRecievedDate.toISOString() : <any>undefined;
        data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["formId"] = this.formId;
        data["certificationCreationDate"] = this.certificationCreationDate ? this.certificationCreationDate.toISOString() : <any>undefined;
        data["programName"] = this.programName;
        data["programId"] = this.programId;
        data["hospitalId"] = this.hospitalId;
        data["pharmacyHospitalId"] = this.pharmacyHospitalId;
        data["pharmacyId"] = this.pharmacyId;
        data["jobNumber"] = this.jobNumber;
        data["pharmacyContactFirstName"] = this.pharmacyContactFirstName;
        data["pharmacyContactLastName"] = this.pharmacyContactLastName;
        data["pharmacyName"] = this.pharmacyName;
        data["pharmacyAddress1Text"] = this.pharmacyAddress1Text;
        data["pharmacyAddress2Text"] = this.pharmacyAddress2Text;
        data["pharmacyAddress3Text"] = this.pharmacyAddress3Text;
        data["pharmacyAddress4Text"] = this.pharmacyAddress4Text;
        data["pharmacyCityName"] = this.pharmacyCityName;
        data["pharmacyStateCode"] = this.pharmacyStateCode;
        data["pharmacyCountryCode"] = this.pharmacyCountryCode;
        data["pharmacyZipCode"] = this.pharmacyZipCode;
        data["pharmacyContactFirstNameCheck"] = this.pharmacyContactFirstNameCheck;
        data["pharmacyContactLastNameCheck"] = this.pharmacyContactLastNameCheck;
        data["pharmacyFirstNameCheck"] = this.pharmacyFirstNameCheck;
        data["pharmacyAddress1TextCheck"] = this.pharmacyAddress1TextCheck;
        data["pharmacyAddress2TextCheck"] = this.pharmacyAddress2TextCheck;
        data["pharmacyStateCodeFKCheck"] = this.pharmacyStateCodeFKCheck;
        data["pharmacyCityNameCheck"] = this.pharmacyCityNameCheck;
        data["pharmacyZipCodeCheck"] = this.pharmacyZipCodeCheck;
        data["reasonForModification"] = this.reasonForModification;
        data["isSignature"] = this.isSignature;
        data["isSignatureStamped"] = this.isSignatureStamped;
        data["signedDate"] = this.signedDate ? this.signedDate.toISOString() : <any>undefined;
        data["contactComments"] = this.contactComments;
        data["isAdverseEvent"] = this.isAdverseEvent;
        data["affiliationTypeClassificationValueId"] = this.affiliationTypeClassificationValueId;
        data["slnLicenseExpirationDate"] = this.slnLicenseExpirationDate ? this.slnLicenseExpirationDate.toISOString() : <any>undefined;
        data["slnStateCode"] = this.slnStateCode;
        data["stateLicenseNbr"] = this.stateLicenseNbr;
        data["pharmacyKID"] = this.pharmacyKID;
        data["pharmacyContactEmail"] = this.pharmacyContactEmail;
        data["pharmacyContactFAX"] = this.pharmacyContactFAX;
        data["pharmacyContactPhoneNumber"] = this.pharmacyContactPhoneNumber;
        return data;
    }

    clone(): CertificationDetailDto {
        const json = this.toJSON();
        let result = new CertificationDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICertificationDetailDto {
    certificationDetailId: string | undefined;
    tenantName: string | undefined;
    /** Communication ID:- This is not in reference to communication database foriegn key
should be traeted as seprate entity. */
    communicationId: string | undefined;
    communicationRecievedDate: Date | undefined;
    batchDate: Date | undefined;
    batchNumber: string | undefined;
    formId: string | undefined;
    certificationCreationDate: Date | undefined;
    programName: string | undefined;
    programId: string | undefined;
    hospitalId: string | undefined;
    pharmacyHospitalId: string | undefined;
    pharmacyId: string | undefined;
    jobNumber: string | undefined;
    pharmacyContactFirstName: string | undefined;
    pharmacyContactLastName: string | undefined;
    pharmacyName: string | undefined;
    pharmacyAddress1Text: string | undefined;
    pharmacyAddress2Text: string | undefined;
    pharmacyAddress3Text: string | undefined;
    pharmacyAddress4Text: string | undefined;
    pharmacyCityName: string | undefined;
    pharmacyStateCode: string | undefined;
    pharmacyCountryCode: string | undefined;
    pharmacyZipCode: string | undefined;
    pharmacyContactFirstNameCheck: boolean | undefined;
    pharmacyContactLastNameCheck: boolean | undefined;
    pharmacyFirstNameCheck: boolean | undefined;
    pharmacyAddress1TextCheck: boolean | undefined;
    pharmacyAddress2TextCheck: boolean | undefined;
    pharmacyStateCodeFKCheck: boolean | undefined;
    pharmacyCityNameCheck: boolean | undefined;
    pharmacyZipCodeCheck: boolean | undefined;
    reasonForModification: string | undefined;
    isSignature: boolean | undefined;
    isSignatureStamped: boolean | undefined;
    signedDate: Date | undefined;
    contactComments: string | undefined;
    isAdverseEvent: boolean | undefined;
    affiliationTypeClassificationValueId: string | undefined;
    slnLicenseExpirationDate: Date | undefined;
    slnStateCode: string | undefined;
    stateLicenseNbr: string | undefined;
    pharmacyKID: string | undefined;
    pharmacyContactEmail: string | undefined;
    pharmacyContactFAX: string | undefined;
    pharmacyContactPhoneNumber: string | undefined;
}

export enum LocalizedValueLanguage {
    _0 = 0,
    _1 = 1,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}